/**
 * @file m站门店选择页面
 */

import React, {Component} from 'react';
import {connect} from 'react-redux';
import {SearchBar, NavBar, Toast,Icon} from 'antd-mobile';
import {TabList, TabContent, NoData} from '../../component/stores/index';
import storage from 'store'
import NavBarComponent from '../../component/common/NavBarComponent';
import {throttle, parseSearchToState, parseStateToSearch} from '../../util/util';
import {
    SAVE_CITY_GAI_INFO,
    SAVE_CITY_GET_INFO,
    SAVE_STORE_GAI_INFO,
    SAVE_STORE_GET_INFO,
    SAVE_START_TIME,
    SAVE_END_TIME
} from '../../redux/actions/homeAction';
import {Http,urls} from '../../api/index'
import './stores.css';

class Stores extends Component {
    constructor(props) {
        super(props);
        
        props.cacheLifecycles.didCache(this.componentDidCache)
        props.cacheLifecycles.didRecover(this.componentDidRecover)
         
        this.state = {
            way:'',
            isStoreList:false,
            isShowNodata:false,
            isSelCity:false,
            cities:[],
            hotCities:[],
            gaiCityId:'',
            gaiCityName:'',
            gaiStorePoint:'',
            gaiStoreName:'',
            gaiStoreId:'',
            backCityId:'',
            backCityName:'',
            backStorePoint:'',
            backStoreName:'',
            backStoreId:'',
            gaiBusinessHours:'',
            backBusinessHours:'',
            bookingGaincarTime:'',
            bookingBackcarTime:'',
            dateDiffNum:'',
            activeIndex: 0,
            activeBg:'#ffffff',
            defaultbg:'#f5f5f5',
            minH:'800px',
            tabs: [],
            tabList:[],
            storesList:[],
            froms:'',
        };
    };
           
    componentDidCache = () => {
        // console.log('List cached')
    }

    componentDidRecover = () => {
        this.search();
    }

    componentDidMount() {
        this.search();
    };

    // 查询地区门店
    search(){
        const {location} = this.props;
        const search = location.search;
        let way = parseSearchToState(search).cityclasses==='1' ? 'gai':'get';
        let {cityName, coordinatePoint, cityId} = parseSearchToState(search);
        this.setState(() => {
            Toast.loading('Loading...');
            return { way};
        });
        let url = urls.storeListByCityId;
        let where = {storePoint: coordinatePoint, cityId};
        const tabsList = [];
        const storesList = [];
        this.setState({
            tabs:[],
            storesList:[],
            tabList:[],
            isStoreList:false
        });
        Http.post({ url, "data":where }).then(res => {
            Toast.hide();
            if(res.code == 0){
                if(res.data.length > 0){
                    res.data.map((item,index)=>{
                        tabsList.push({title:item.areaName,anchor:index});
                        storesList[index] = [];
                        item.storeList.map(storeItem=>{
                            storesList[index].push({...storeItem})
                        })
                    })
                    if(storesList.length > 0){
                        this.setState({
                            activeIndex: 0,
                            tabs:tabsList,
                            storesList:storesList,
                            tabList:storesList[0],
                            isStoreList:true,
                            isShowNodata:false
                        });
                    }
                }else{
                    this.setState({
                        isShowNodata:true
                    })
                }
            }else{
                Toast.fail({
                    content: res.msg,
                    duration: 2000
                });
            }
        });
    };
    // 选择城市
    locationCity = (e) => {
        let cityCode = this.state.way==='gai' ? '1':'2';
        const { location,history } = this.props;
        const search = location.search;
        let pathname = parseSearchToState(search).pathname;
        history.push({
            pathname: '/city',
            search: parseStateToSearch({cityCode,pathname})
        });
    };
    //查询门店列表
    updateStoreList = (tabIndex) => {
        this.setState({
            activeIndex: tabIndex,
            tabList:this.state.storesList[tabIndex]
        })
    };
    // 存储换车城市和门店信息
    storageGetInfo = (cityInfo) =>{
        sessionStorage.setItem('getStoreInfoFromStores', JSON.stringify(cityInfo));
        sessionStorage.setItem('getCityInfoFromStores', JSON.stringify(cityInfo));
        this.props.dispatch(SAVE_STORE_GET_INFO({getStoreInfo: {...cityInfo}}));
        this.props.dispatch(SAVE_CITY_GET_INFO({getCityInfo: {...cityInfo}}));
    };
    // 存储取车城市和门店信息
    storageGaiInfo = (cityInfo) =>{
        sessionStorage.setItem('gaiStoreInfoFromStores', JSON.stringify(cityInfo));
        sessionStorage.setItem('gaiCityInfoFromStores', JSON.stringify(cityInfo));
        this.props.dispatch(SAVE_STORE_GAI_INFO({gaiStoreInfo: {...cityInfo}}));
        this.props.dispatch(SAVE_CITY_GAI_INFO({gaiCityInfo: {...cityInfo}}));
    };
    // 选择门店
    checkStore = cityInfo => {
        const {location,history} = this.props;
        const search = location.search;
        let params = parseSearchToState(search);
        let {coordinatePoint,pathname, cityId} = parseSearchToState(search);
        let carListParams = JSON.parse(sessionStorage.getItem('carListParams'));
        cityInfo.coordinatePoint = coordinatePoint;
        // showNodata状态是fasle
        this.setState({
            isShowNodata:false
        });
        // 判断页面来源from车型选择
        if (pathname === '/carList'){
            // 存储取还车城市信息
            this.storageGetInfo(cityInfo);
            // 存储取车城市信息
            if(this.state.way==='gai'){
                this.storageGaiInfo(cityInfo);
            }
            history.push({
                pathname: '/carList',
                search: parseStateToSearch({...params, from: history.location.pathname})
            });
        }
        // 页面来自首页或者城市选择
        if(pathname === '/' || !pathname || pathname === 'undefined'){
            // 存储取还车城市信息
            this.storageGetInfo(cityInfo);
            // 存储取车城市信息
            if(this.state.way==='gai'){
                this.storageGaiInfo(cityInfo);
            };
            history.push({
                pathname: '/'
            });
        }
    };
    // 返回事件
    goBack = () =>{
        // const {location,history} = this.props;
        // const search = location.search;
        // let {pathname} = parseSearchToState(search);
        // let carListParams = JSON.parse(sessionStorage.getItem('carListParams'));
        // if (pathname === '/carList'){
        //     history.push({
        //         pathname: '/carList',
        //         search: parseStateToSearch({...carListParams, from: history.location.pathname})
        //     });
        // }
        // if(pathname === '/' || !pathname){
        //     history.push({
        //         pathname: '/',
        //     });
        // }
        this.props.history.goBack();
    };
    // 查询门店详情
    storeDetail = (storeId) => {
        const { history } = this.props;
        history.push({
            pathname: '/storeDetail',
            search: parseStateToSearch({storeId})
        });
    };
    render() {
        const {isStoreList,tabs,activeIndex,tabList,isShowNodata} = this.state;
        return (
            <div className="page stores" >
                <div className="stores-top">
                    <NavBarComponent>
                        <NavBar
                            mode="light"
                            icon={ <Icon type="left" color='#333' /> }
                            leftContent=""
                            onLeftClick={ this.goBack }
                            >
                                门店选择
                        </NavBar>
                    </NavBarComponent>
                    <form className="am-search" action="#">
                        <div className="am-search-input">
                            <div className="am-search-synthetic-ph" onClick={ this.locationCity }>
                                <span className="am-search-synthetic-ph-container">
                                    <i className="am-search-synthetic-ph-icon"></i>
                                    <span className="am-search-synthetic-ph-placeholder">请输入地址搜索门店</span>
                                </span>
                            </div>
                            <div className="am-search-value"></div>
                            <a className="am-search-clear"></a>
                        </div>
                    </form>
                </div>
                <div className="shadow-page" style={{display:isStoreList ? 'block':'none'}}>
                    <div className="tabs-list shadow-box">
                        <TabList tabs={tabs} activeIndex={activeIndex} updateStoreList={this.updateStoreList}></TabList>
                        <TabContent tabContents={tabList} checkStore={this.checkStore} storeDetail={this.storeDetail}></TabContent>
                    </div>
                </div>
                <NoData isShowNodata={isShowNodata}></NoData>
           </div>
        );
    }
}

const mapStateToProps = state => {
    let params = state.homeReducer;
    return {
        gaiCityInfo: params.gaiCityInfo,
        getCityInfo: params.getCityInfo,
        gaiStoreInfo: params.gaiStoreInfo,
        getStoreInfo: params.getStoreInfo,
        startTime: params.startTime,
        endTime: params.endTime
    };
};

Stores = connect(mapStateToProps)(Stores);

export default Stores;
